import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
export function BlotterPanelHeaderTitleLayout({ children }: Props) {
  return <h3 className="card-title line-height-1 mb-0">{children}</h3>;
}
